// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uH0c7","name":"styles_name__25F4V","phone":"styles_phone__1hsGN"};